/**
 * Reusable badge for scheduled date/time display.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { cn } from '@/lib/utils';

export interface ScheduledBadgeProps {
  scheduleLabel: string;
  /** When true, style as past/overdue (scheduled instant before now; label is Copenhagen local). */
  isPast?: boolean;
  className?: string;
}

export const ScheduledBadge: FC<ScheduledBadgeProps> = ({ scheduleLabel, isPast, className }) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center rounded-md border px-2 py-0.5 text-[11px] font-medium',
      isPast
        ? 'border-destructive/50 bg-destructive/10 text-destructive'
        : 'border-primary/40 bg-primary/10 text-primary',
      className,
    )}
    title={scheduleLabel}
  >
    Scheduled {scheduleLabel}
  </span>
);
